import React, { CSSProperties, ReactNode } from 'react';

import { cn } from '@lib/utils';

import styles from './RadioButton.module.css';

type Props = {
  checked: boolean;
  onChange: (value: boolean) => void;
  label?: string;
  RightIcon?: ReactNode;
  size?: number;
};

const RadioButton = ({
  checked,
  onChange,
  label,
  RightIcon,
  size = 24
}: Props) => {
  const outerCircle: CSSProperties = {
    width: size,
    height: size,
    borderRadius: size / 2
  };

  const innerCircle: CSSProperties = {
    width: size - 10,
    height: size - 10,
    borderRadius: (size - 10) / 2
  };

  return (
    <div
      className={cn(
        styles.wrapper,
        checked ? styles.selected : styles.unselected
      )}
      onClick={() => onChange(!checked)}
    >
      <div className={styles.radioWrapper}>
        <div className={styles.radioButton} style={outerCircle}>
          {checked && (
            <div className={styles.radioButtonChecked} style={innerCircle} />
          )}
        </div>

        <span>{label}</span>
      </div>

      {RightIcon}
    </div>
  );
};

export default RadioButton;
